<div class="com-year-picker-header">
  <div class="com-year-picker-previous" (click)="previousPage()">
    <i class="fa fa-chevron-left"></i>
  </div>
  <div class="com-year-picker-title"><span style="margin-right: 20px;">Year:</span>{{ firstYear }}-{{ lastYear }}</div>
  <div class="com-year-picker-next" (click)="nextPage()">
    <i class="fa fa-chevron-right"></i>
  </div>
</div>
<ul class="com-year-picker-wrapper">
  <li class="com-picker-item" [ngClass]="{'com-selected-item':year===currentYear,'com-disabled-item':!isValidYear(year)}" (click)="yearClick(year)"
    *ngFor="let year of yearList">
    <span>{{ year }}</span>
  </li>
</ul>
